import { createStore } from 'zustand/vanilla';

import BirthUtils from '@MP/shared/utils/BirthUtils';
import PhoneNumberUtils from '@MP/shared/utils/PhoneNumberUtils';
import ReplaceUtils from '@MP/shared/utils/ReplaceUtils';

export interface PatientAddFormDataState {
  orgId: number;
  code: string;
  name: string;
  phoneNumber: string;
  birth: string;
  requiredPhoneNumber: boolean;
  validCode: boolean | undefined;
  checkCode: boolean;
  setExistsCode: (exists: boolean) => void;
  setCode: (code: string) => void;
  setName: (name: string) => void;
  setBirth: (birth: string) => void;
  setPhoneNumber: (phoneNumber: string) => void;
  validateBirth: () => boolean;
  validatePhoneNumber: () => boolean;
}

export const createPatientAddFormDataStore = (orgId: number, checkCode: boolean, requiredPhoneNumber?: boolean) =>
  createStore<PatientAddFormDataState>((set, get) => ({
    orgId,
    code: '',
    name: '',
    phoneNumber: '',
    birth: '',
    requiredPhoneNumber: requiredPhoneNumber || false,
    validCode: undefined,
    checkCode: checkCode || false,

    setExistsCode: (exists) => set({ validCode: !exists }),
    setCode: (code) => set({ code: code.trim(), validCode: undefined }),
    setName: (name) => set({ name: name.trim() }),
    setBirth: (birth) => {
      if (birth.length <= 8) {
        set({ birth: ReplaceUtils.replaceNumber(birth) });
      }
    },
    setPhoneNumber: (phoneNumber) => {
      if (phoneNumber.length <= 11) {
        set({ phoneNumber: ReplaceUtils.replaceNumber(phoneNumber) });
      }
    },

    validateBirth: () => BirthUtils.isValid(get().birth),
    validatePhoneNumber: () => {
      const { phoneNumber, requiredPhoneNumber } = get();
      if (phoneNumber) {
        return PhoneNumberUtils.isValid(phoneNumber);
      }
      return requiredPhoneNumber ? false : true;
    },
  }));

export type PatientAddFormDataStoreApi = ReturnType<typeof createPatientAddFormDataStore>;

export const selectIsValid = (s: PatientAddFormDataState): boolean => {
  if (s.checkCode) {
    return !!s.name && s.validateBirth() && s.validatePhoneNumber() && !!s.code && !!s.validCode;
  }
  return !!s.name && s.validateBirth() && s.validatePhoneNumber();
};

/** 폼이 읽는 필드·액션 묶음(모두 원시값·안정 참조). useShallow와 함께 구독한다. */
export const selectAddFormFields = (s: PatientAddFormDataState) => ({
  code: s.code,
  name: s.name,
  phoneNumber: s.phoneNumber,
  birth: s.birth,
  setExistsCode: s.setExistsCode,
  setCode: s.setCode,
  setName: s.setName,
  setBirth: s.setBirth,
  setPhoneNumber: s.setPhoneNumber,
  validateBirth: s.validateBirth,
  validatePhoneNumber: s.validatePhoneNumber,
});
